export class Role {
    role_id: number;
    role_name: string;
    role_desc: string;
}

export class EkpayUser {
    ekpay_id: string;
    login?: any;
    user_id: string;
    pass: string;
    mpin?: any;
    status: number;
    activated: boolean;
    user_name: string;
    mobile: string;
    email_id: string;
    dob: string;
    address: string;
    gender: string;
    nid: string;
    default_lang: string;
    is_auto_login: boolean;
    is_bill_paid: boolean;
    creation_time: Date;
    profile_update_time: Date;
    created_by: string;
    updated_by: string;
    reg_mode?: any;
    roles: Role[];
}

export class EkpayUserResponse {
    response: string;
    reason: string;
    ekpay_user: EkpayUser;
}


// WEBPACK FOOTER //
// ./src/app/user/ekpay_user.ts